var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"base-toggle"},[_c('input',{staticClass:"checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"click":_vm.onClick}}),_c('div',{staticClass:"slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }